import { Droppable } from '@hello-pangea/dnd';
import { FC, HTMLAttributes, PropsWithChildren } from 'react';

interface Props extends HTMLAttributes<HTMLDivElement> {
	droppableId: string;
}

export const SortableContent: FC<PropsWithChildren<Props>> = ({ droppableId, children, ...props }) => {
	return (
		<Droppable droppableId={droppableId}>
			{(provided) => (
				<div ref={provided.innerRef} {...provided.droppableProps} {...props}>
					{children}
					{provided.placeholder}
				</div>
			)}
		</Droppable>
	);
};
